<template>
  <v-card>
    <!-- <v-tabs id="pick-date-popup-tabs" grow active-class="active-teacher-type-case-tab">
     <v-tabs-slider color="red"></v-tabs-slider>
      <v-tab v-for="(teacherTypeItem, i) in teacherTypeList" :key="i" @click="changeTeacherTypeTab(teacherTypeItem.id)">GV {{ teacherTypeItem.name.toUpperCase() }}</v-tab>
    </v-tabs> -->
    <v-form ref="form" v-model="valid">
      <v-row class="px-3">
        <v-col
          cols="4"
        >
          <v-autocomplete
            v-model="curriculumId"
            :items="curricilumInterview"
            item-text="name"
            item-value="id"
            label="Chọn chương trình phỏng vấn"
            placeholder="Chọn chương trình phỏng vấn"
            @change="getSubjectInterview()"
            :rules="[v => !!v || 'Chương trình test là 1 trường bắt buộc']"
          />
        </v-col>
        <v-col
          cols="4"
        >
          <v-autocomplete
            v-model="regionTypeId"
            :items="listRegionType"
            item-text="name"
            item-value="id"
            label="Chọn giáo viên phỏng vấn"
            placeholder="Chọn giáo viên phỏng vấn"
            @change="getSubjectInterview()"
            :rules="[v => !!v || 'Giáo viên test là 1 trường bắt buộc']"
          />
        </v-col>
        <v-col
          cols="4"
        >
          <v-autocomplete
            v-model="caseTypeId"
            :items="listCaseType"
            item-text="name"
            item-value="id"
            label="Chọn ca phỏng vấn"
            placeholder="Chọn ca phỏng vấn"
            @change="getSubjectInterview()"
            :rules="[v => !!v || 'Ca test là 1 trường bắt buộc']"
          />
        </v-col>
      </v-row>
    </v-form>
    <div style="height: 400px; overflow-y: auto;">
      <table class="table-pre" style="width: 100%; border-collapse: collapse">
        <tr class="table-header">
          <th style="text-align: left"><span class="ml-4">Ca test</span></th>
          <th v-for="(time, index) in timeContact" :key="index">
            <div class="day-of-week">
              <b>{{ time.dayOfWeek }}</b>
              <span>{{ time.longDate }}</span>
            </div>
          </th>
        </tr>

        <tbody v-if="getContact.length">
          <tr
              class="table-content table-border"
              v-for="(item, indx) in getContact"
              :key="indx"
          >
            <td style="text-align: left">
              <span class="ml-4">{{ item.interviewCaseTime }}</span>
              <v-icon
                  v-if="item.interviewCaseType == 3"
                  class="status-reserve "
                  color="#6600CC"
                  style="font-size: 10px; margin: 0px 6px 0px 7px;"
              >mdi-star</v-icon
              >
              <v-icon
                  v-if="item.interviewCaseType == 1"
                  class="status-30 status-icon"
                  color="#F2994A"
              >mdi-circle-small</v-icon
              >
              <v-icon
                  v-if="item.interviewCaseType == 2"
                  class="status-20 status-icon"
                  color="#2F80ED"
              >mdi-circle-small</v-icon
              >
            </td>
            <td v-for="(registered, index) in item.data" :key="index">
              <svg
                class="stroke-active"
                @click="checkRegistered(registered)"
                v-if="registered.canEdit"
                :class="
                  (activeRes == registered.interviewCalendarId && registered.isRegistered) ? 'stroke-color' :''
                "
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM11.4 6.45C11.6 6.25 11.6 5.95 11.4 5.75C11.2 5.55 10.9 5.55 10.7 5.75L6.4 10.05L4.85 8.5C4.65 8.3 4.3 8.3 4.15 8.5C4 8.7 4 9 4.15 9.2L6.05 11.1C6.25 11.3 6.55 11.3 6.75 11.1L11.4 6.45Z"
                    fill="#E0E0E0"
                />
              </svg>
              <svg
                  class="disabledStroke"
                  v-if="!registered.canEdit"
                  :class="
                  (registered.isTmpRegistered) ? 'stroke-color' :''
                "
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM11.4 6.45C11.6 6.25 11.6 5.95 11.4 5.75C11.2 5.55 10.9 5.55 10.7 5.75L6.4 10.05L4.85 8.5C4.65 8.3 4.3 8.3 4.15 8.5C4 8.7 4 9 4.15 9.2L6.05 11.1C6.25 11.3 6.55 11.3 6.75 11.1L11.4 6.45Z"
                    fill="#E0E0E0"
                />
              </svg>
    <!--          <svg-->
    <!--            v-if="registered.interviewCalendarId == null"-->
    <!--            class="disabledStroke"-->
    <!--            width="16"-->
    <!--            height="16"-->
    <!--            viewBox="0 0 16 16"-->
    <!--            fill="none"-->
    <!--            xmlns="http://www.w3.org/2000/svg"-->
    <!--          >-->
    <!--            <path-->
    <!--              d="M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM11.4 6.45C11.6 6.25 11.6 5.95 11.4 5.75C11.2 5.55 10.9 5.55 10.7 5.75L6.4 10.05L4.85 8.5C4.65 8.3 4.3 8.3 4.15 8.5C4 8.7 4 9 4.15 9.2L6.05 11.1C6.25 11.3 6.55 11.3 6.75 11.1L11.4 6.45Z"-->
    <!--              fill="#E0E0E0"-->
    <!--            />-->
    <!--          </svg>-->
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="py-10" colspan="4" style="color: red;" v-if="isCallApi">
              <v-icon class="mdi-spin" color="#00CAE3" large>mdi-loading</v-icon>
            </td>
            <td class="py-10" colspan="4" style="color: red;" v-else>
              <i>(Bạn chọn chương trình phỏng vấn trước nhé!)</i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <v-row>
      <v-col cols="12" md="6">
        <div class="d-flex" style="margin-left: 17px;margin-top: 17px;">
          <h4 class="mr-3 pick-child-title" style="margin-top:12px;white-space: nowrap;">
            Chọn con test*
          </h4>
          <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              rules="required"
              name="Chọn con"
          >
            <v-select
                attach
                :menu-props="{ bottom: true, offsetY: true ,  maxHeight: 160}"
                class="select-child-option"
                dense
                :error-messages="errors"
                placeholder="Chọn tên con"
                clearable
                :items="contacts.childCustomer"
                item-text="fullName"
                v-model="selectChild"
                item-value="id"
                solo
            ></v-select>
          </validation-provider>
        </div>
      </v-col>
    </v-row>
    <v-text-field
        name="name"
        label="Note"
        id="id"
        class="pick-date-note"
        clearable
        v-model="notePickDate"
    ></v-text-field>
    <v-card-actions
        class="d-flex justify-end"
        style="background:rgba(56, 56, 56, 0.1)"
    >
      <v-btn
          @click="closeModal"
          color="#F7F7FC"
          rounded
          width="100"
          height="30"
          style="color:#14142B"
      >Hủy bỏ</v-btn
      >
      <v-btn
          :disabled="!activeRes || !selectChild"
          color="#FF6609"
          rounded
          width="100"
          height="30"
          @click.prevent="createContactInterviews"
      >Lưu lại</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import TutorTestRepository from "../../../repositories/TutorTestRepository";
import Cookies from "js-cookie";
export default {
  props: ["contacts", "isCancel", "interviewDetailId", "book", "curriculums"],
  async mounted() {
    await this.getListTeacherTypes();
    if (this.book){
      this.selectChild = this.book.customerId
      this.activeRes = this.book.interviewCalendarId
      this.curriculumId = this.book.curriculumId;
      this.regionTypeId = this.book.teacherTypeId;
      this.caseTypeId = this.book.caseId;
      this.valid = await this.$refs.form.validate();
      await this.getSubjectInterview();
    }
  },
  data() {
    return {
      valid: false,
      strokeColor: false,
      isCallApi: false,
      getContact: [],
      subjectId: null,
      timeContact: {},
      activeRes: null,
      selectChild:null,
      notePickDate:null,
      teacherTypeCaseId: 0,
      tabsTeacherType: 0,
      mapIdTeacherTypeCase: {},
      teacherTypeList: [],
      curriculumId: null,
      listCaseType: [],
      caseTypeId: null,
      listRegionType: [],
      regionTypeId: null,
      curricilumInterview: []
    };
  },
  async created() {
    this.getListRegionType();
    this.getListCaseType();
    this.filterCurriculum();
    Bus.$on("closeDialog", () => {
      this.closeModal()
    })
    Bus.$off('reload-schedule-date-time')
    Bus.$on('reload-schedule-date-time',()=>{
      this.notePickDate = null
      this.getSubjectInterview()
    })
  },
  watch: {
    contactId: {
      handler: async function () {
        await this.getSubjectInterview();
      },
      deep: true,
    },
    isCancel: {
      deep: true,
    },
    interviewDetailId: {
      deep: true,
    },
    book: {
     handler: function(val) {
       if (val){
         this.selectChild = val.customerId
         this.activeRes = val.interviewCalendarId;
       }
       //this.getSubjectInterview()
     }
    },
  },
  methods: {
    checkRegistered(registered) {
      this.getContact.forEach(item => {
        item.data.forEach(itemData => {
          itemData.isRegistered = false;
          if (itemData.interviewCalendarId == registered.interviewCalendarId) {
            itemData.isRegistered = !registered.isRegistered;
          }
        });
      });
      // console.log("registered.isRegistered", registered.isRegistered)
      // registered.isRegistered = !registered.isRegistered
      // console.log("!registered.isRegistered", registered.isRegistered)
      this.activeRes = registered.interviewCalendarId;
    },
    async getSubjectInterview() {
      if (this.$refs.form) {
        this.valid = this.$refs.form.validate();
        if (this.valid) {
          const curriculum = this.curricilumInterview.find(s => s.id === this.curriculumId);
          this.subjectId = curriculum.subject_id;
          try {
            this.getContactInterviews(this.subjectId);
          } catch (error) { }
        }
      }
    },

    async getContactInterviews(subjectId) {
      this.isCallApi = true;
      this.getContact = [];
      const params = {
        curriculumId: this.curriculumId,
        teacherType: this.regionTypeId,
        caseId: this.caseTypeId,
      };
      let res = await TutorTestRepository.getContactInterviews(
          this.contacts.id,
          subjectId,
          params,
      );
      this.getContact = res.data;
      this.getContact.forEach(item => {
        item.data.forEach(itemData => {
          itemData.isTmpRegistered = itemData.isRegistered
          if (this.activeRes != itemData.interviewCalendarId && itemData.isRegistered) {
            itemData.canEdit = false;
          }
        })
      })
      this.timeContact = res.data[0].data;
      this.isCallApi = false;
    },

    async createContactInterviews() {
      const loading = this.$loading.show()
      let params = {
        contactId: this.contacts.id,
        customerId: this.selectChild,
        subjectId: this.subjectId,
        interviewCalenderId: this.activeRes,
      };
      let res;
      if (this.isCancel) {
        res = await TutorTestRepository.createContactInterviews(params);
      } else {
        res = await TutorTestRepository.updatePractice(
            this.interviewDetailId,
            params
        );
      }
      loading.hide()
      if (res.success) {
        this.$swal({
          icon: "success",
          title: "Tạo lịch thành công",
          showConfirmButton: false,
          timer: 1000
        }).then(() => {
          Bus.$emit('note-pick-date',{note:this.notePickDate,contactId:this.contacts.id,contactTutorPracticeId:_.get(res,['data','contactTutorPractice','id'])})
          this.$emit("getInterviews");
          Bus.$emit('close-modal-pick')
          Bus.$emit('reload-interview')
        });
        this.activeRes = null;
      } else if(res.message == 'Item existed'){
        this.$swal({
          type: "error",
          icon: "error",
          title: "Lịch phỏng vấn này đã tồn tại",
        })
      } else {
        this.$swal({
          type: "error",
          icon: "error",
          title: _.get(res,['message']),
        })
      }
    },
    closeModal() {
      this.activeRes = null;
      this.selectChild = null
      Bus.$emit("close-modal-pick");
    },
    async getListTeacherTypes(){
      const listTeacherType = await TutorTestRepository.getListTeacherTypesV3();
      this.teacherTypeList = listTeacherType.data
      if (this.teacherTypeList){
        this.teacherTypeCaseId = this.teacherTypeList[0] ? this.teacherTypeList[0].id : 0;
        this.teacherTypeList.forEach((item) => {
          this.mapIdTeacherTypeCase[item.id] = {name: item.name, caseId: item.case_id, teacherTypeId: item.teacher_type_id};
        })
      }
    },
    async changeTeacherTypeTab(teacherTypeCaseId){
      const loading = this.$loading.show()
      this.teacherTypeCaseId = teacherTypeCaseId;
      await this.getSubjectInterview();
      loading.hide()
    },

    // Lấy danh sách thời gian
    async getListCaseType() {
      const res = await TutorTestRepository.getListCaseTypes();
      this.listCaseType = _.get(res, 'data');
    },

    // Lấy danh sách khu vực loại giáo viên
    async getListRegionType() {
      const res = await TutorTestRepository.getListTeacherTypes();
      this.listRegionType = _.get(res, 'data');
    },
    filterCurriculum() {
      for (const curriculum of this.curriculums) {
        for (const item of curriculum.test_type) {
          if (item.type_placement_test == "interview") {
            this.curricilumInterview.push(curriculum)
          }
        }
      }
      this.curricilumInterview = _.uniqBy(this.curricilumInterview, 'id')
    }
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap");
table {
  border-radius: 8px;
  background: white;
  th,
  td {
    border: none;
  }
  td {
    text-align: center;
    position: relative;
    .icon-edit {
      font-size: 16px;
      position: absolute;
      right: 0;
    }
  }
  .table-header {
    height: 40px;
    background: #f2f2f2;
    font-weight: 700;
    font-family: "Montserrat", 700;
    th {
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 20px;
      color: #333333;
    }
  }
  .table-content {
    height: 60px;
    align-items: center;
    b {
      margin-right: 5px;
    }
    .subject {
      display: flex;
      text-align: left;
      padding-left: 24px;
      .v-icon {
        font-size: 20px;
        color: #0395ee;
      }
      .info-subject {
        display: inline-grid;
        margin-left: 22px;
        b {
          text-transform: capitalize;
        }
        span {
          font-size: 10px;
          color: #828282;
        }
      }
    }
  }
  .table-border {
    // &:last-child {
    //   border-bottom: unset;
    // }
    border-bottom: 1px solid #eff0f7;
  }
}
.pagination-table {
  text-align: right;
  padding: 20px 215px;
  .v-pagination.v-pagination {
    justify-content: right;
  }
}
.title-preinterview {
  height: 52px;
  background: #f7f7fc;
}
.day-of-week {
  display: inline-grid;
  margin-top: 6px;
  span {
    font-family: Roboto;
    font-style: normal;
    font-size: 10px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0;
    color: #6e7191;
  }
}
.stroke-color {
  stroke: #25e8c8!important;
}
.disabledStroke.stroke-color {
  stroke: #a7f2e6 !important;
}
.stroke-active {
  stroke: rgb(80, 80, 80);
}

.disabledStroke {
  stroke: #f7faf9;
}
.pick-child-title{
  font-style: italic;
  font-size: 11px;
  line-height:13px;
  color:#343A40;
}
.select-child-option{
  .v-input__control{
    min-height: 34px!important;
  }
}
</style>
<style lang="scss">
.pick-date-note {
  background: rgba(56, 56, 56, 0.1);
  margin-top: 0 !important;
  .v-input__control {
    padding-left: 21px !important;
    .v-input__slot {
      margin-bottom: 0 !important;
    }
  }
}
.status-icon{
  font-size: 30px!important;
}
.active-teacher-type-case-tab{
  background-color: #e91e63;
  color: #ffffff !important;
}
</style>
